// Hazard codes highlighted in the dangerous goods table.
//  - RED: especially dangerous. Shown red AND pre-fill FSS 7 relevance to Yes.
//  - YELLOW: dangerous. Shown yellow only, no effect on FSS 7.
// Matching ignores case. A code with a suffix (e.g. H360FD) is matched exactly,
// so list every variant that should be coloured.

export const RED_HAZARD_CODES = [
  "H200", "H201", "H202", "H203", "H240", "H241", "H250", "H300", "H310",
  "H330", "H340", "H350", "H350i", "H360", "H360F", "H360D", "H360FD",
  "H360Fd", "H360Dd", "H370", "H372",
];

export const YELLOW_HAZARD_CODES = [
  "H204", "H205", "H301", "H304", "H311", "H317", "H331", "H334", "H341",
  "H351", "H361", "H361f", "H361d", "H361fd", "H371", "H373",
];

const RED_SET = new Set(RED_HAZARD_CODES.map((code) => code.toUpperCase()));
const YELLOW_SET = new Set(YELLOW_HAZARD_CODES.map((code) => code.toUpperCase()));

// "red", "yellow" or "" for a single code.
export function hazardSeverity(code) {
  const normalized = String(code || "").toUpperCase();
  if (RED_SET.has(normalized)) return "red";
  if (YELLOW_SET.has(normalized)) return "yellow";
  return "";
}

export function isRedHazardCode(code) {
  return RED_SET.has(String(code || "").toUpperCase());
}

// True when any code triggers FSS 7 relevance (i.e. is red).
export function hasCriticalHazardCode(codes) {
  return (codes || []).some((code) => isRedHazardCode(code));
}
